var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "scrollTo",
      staticClass: "brochure-form",
      attrs: { name: "brochureRequest", novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm.apiError
        ? _c("div", { staticClass: "error-message mb-20" }, [
            _c("div", { staticClass: "error-message__icon" }),
            _vm._v(" "),
            _c("div", { staticClass: "error-message__text" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.apiErrorMessage
                      ? _vm.apiErrorMessage
                      : "The brochure request could not be completed!"
                  )
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "brochure-form__introduction",
        domProps: { innerHTML: _vm._s(_vm.data.formFillIntroductionHtml) },
      }),
      _vm._v(" "),
      _vm._l(_vm.fields, function (field, fieldName) {
        return _c("Input", {
          key: fieldName,
          attrs: {
            name: fieldName,
            type: field.type,
            label: field.label,
            placeholder: field.label,
            required: field.required !== false,
            options: field.options,
            pattern: field.pattern,
            title: field.title,
            vuexPath: _vm.vuexPath,
          },
        })
      }),
      _vm._v(" "),
      _c(
        "AddressLookup",
        { attrs: { vuexPath: _vm.vuexAddressPath, brandName: _vm.data.brand } },
        [
          _c("p", [
            _vm._v(
              "\n      " + _vm._s(_vm.data.countryDownloadWarning) + "\n      "
            ),
            _c(
              "button",
              {
                staticClass: "link",
                attrs: {
                  "aria-label": "Download a brochure",
                  title: "Click to download a brochure",
                },
                on: { click: _vm.changeState },
              },
              [_vm._v("Download a Brochure")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "brochure-form__disclaimer",
        domProps: { innerHTML: _vm._s(_vm.data.disclaimerHtml) },
      }),
      _vm._v(" "),
      _c("Input", {
        attrs: {
          name: "marketingEmail",
          type: "checkbox",
          startingValue: true,
          label: _vm.marketingEmailLabel(),
          vuexPath: _vm.vuexPath,
        },
      }),
      _vm._v(" "),
      _c("Input", {
        staticClass: "d-none",
        attrs: {
          name: "marketingMail",
          type: "checkbox",
          startingValue: true,
          label: _vm.marketingMailLabel(),
          vuexPath: _vm.vuexPath,
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn",
          attrs: {
            "aria-label": "Request brochure",
            title: "Click to request a brochure",
          },
        },
        [_vm._v("Request Brochure")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "brochure-form__privacy" }, [
        _vm.data.brochurePrivacy
          ? _c("p", {
              domProps: { innerHTML: _vm._s(_vm.data.brochurePrivacy) },
            })
          : _c("p", [
              _vm._v(
                "\n      " + _vm._s(_vm.data.privacyLinkMessage) + "\n      "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.data.privacyPolicyLink.url,
                    target: _vm.data.privacyPolicyLink.target,
                  },
                },
                [
                  _vm._v(
                    "\n         " +
                      _vm._s(_vm.data.privacyPolicyLink.name) +
                      "\n      "
                  ),
                ]
              ),
            ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }